import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectStudentProfileRetrieval = createSelector(
  [(state: AppState) => state.student.profileRetrieval],
  ({ data, fetching }) => ({
    data,
    fetching,
  }),
);
